<template>
  <div
    class="site no-flex fit-content"
    :class="{ 'layout': Modernizr.flexbox, 'vertical': Modernizr.flexbox, 'fit': Modernizr.flexbox }"
  >
    <header class="full-width" v-if="loaded">
      <ii-header/>
      <ii-navigation/>
    </header>
    <main class="self-stretch flex-auto layout vertical full-width">
      <div class="loader-start" v-if="loading">
        <loader color="white"/>
      </div>
      <router-view v-else :key="$route.fullPath" class="container flex-1"/>
    </main>

    <ii-footer v-if="loaded"/>
  </div>
</template>

<script>
import Vue from 'vue';
import Header from '@components/Header.vue';
import Footer from '@components/Footer.vue';
import Navigation from '@components/Navigation.vue';
import loading from '@shared/mixins/loading';
import Loader from '@shared/components/Loader';
import {mapActions, mapState} from 'vuex';

import '@shared/styles/flex.css';
import '@styles/style.css';
import './styles/login.css';

export default {
    name: 'app',

    mixins: [loading],

    data() {
        return {
            Modernizr: window.Modernizr,
        };
    },

    created() {
        this.startLoading();
        this.updateCountryCode('global')
            .then(this.loadSupportedLanguages)
            .then(this.getNewFeatureIdc)
            .then(()=>{
              if (this.newFeatureIdc) {
                return this.loadFromIpCountry()
              }
            })
            .then(this.determineUserLang)
            .finally(this.stopLoading);
    },
    methods: {
        ...mapActions('locale', [
            'updateCountryCode',
            'loadSupportedLanguages',
            'determineUserLang',
            'loadFromIpCountry'
        ]),
      ...mapActions('loggedIn', ['getNewFeatureIdc']),
    },
    computed: {
      ...mapState('loggedIn', ['newFeatureIdc']),
    },
    components: {
        [Navigation.name]: Navigation,
        [Header.name]: Header,
        [Footer.name]: Footer,
        [Loader.name]: Loader,
    },
};
</script>



// WEBPACK FOOTER //
// login/App.vue